import React from "react";
import classNames from "../../classNames";
import { DatePicker, Space } from "antd";
import dayjs from "dayjs";

const noop = () => {};
const defaultProps = {
  type: "text",
  strict: false,
  onChange: noop,
};

function DateRange({
  className,
  _type,
  type,
  strict,
  onChange,
  defaultValue = [],
  required,
  _required,
  // uppercase,
  ...props
}) {
  function onInput(e, string) {
    let value = string;
    const isAllEmpty = value.every((val) => val === "");
    if (isAllEmpty) return onChange([]);
    onChange(value);
  }

  const { RangePicker } = DatePicker;
  const [startDate, endDate] = defaultValue;
  return (
    <div>
      <Space direction="vertical" size={20}>
        <RangePicker
          // onInput={onInput}
          onChange={onInput}
          required={required || _required}
          value={
            defaultValue.length > 0 ? [dayjs(startDate), dayjs(endDate)] : null
          }
          className={classNames(
            "p-2 fw-semibold custom-range-picker",
            className,
          )}
          {...props}
        />
      </Space>
    </div>
  );
}
DateRange.defaultProps = defaultProps;
export default DateRange;
